import {
  RE_FLITCHING_DONE_FAILED,
  RE_FLITCHING_DONE_REQUEST,
  RE_FLITCHING_DONE_SUCCESS,
} from "app/redux/actions/Factory/Peeling/reFlitchingDone/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const reFlitchingDoneReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case RE_FLITCHING_DONE_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case RE_FLITCHING_DONE_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case RE_FLITCHING_DONE_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
